module.exports = __webpack_public_path__ + "img/658.89552ba4.png";